import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ServiceRateKpi } from 'src/app/assabil-sales/models/dtos/service-rate-kpi';

@Component({
  selector: 'service-rate-kpi',
  templateUrl: './service-rate-kpi.component.html',
  styleUrls: ['./service-rate-kpi.component.scss']
})
export class ServiceRateKpiComponent implements OnInit {

  @Input() geoArea;
  @Input() serviceRateKpi : ServiceRateKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod  : string;
  @Input() showDayValues  : boolean;
  @Input() showMtdValues  : boolean;

  
  constructor(protected datepipe: DatePipe) { }

  ngOnInit() {
  }

/*   clickDn() {
    if (this.serviceRateKpi.partnerClusterCode != "ALL") {
      this.onClick.emit({partnerClusterName : this.serviceRateKpi.partnerClusterName, partnerClusterCode : this.serviceRateKpi.partnerClusterCode, geoArea : this.geoArea, kpi : "dnP1"} );
    }
  } */
  
  getCurrentMtdPlannedPartnersCount(serviceRateKpi : ServiceRateKpi){
    return serviceRateKpi.plannedPartnersCount + serviceRateKpi.mtdPlannedPartnersCount;
  }
  getCurrentMtdInvoicedPartnersCount(serviceRateKpi : ServiceRateKpi){
    return serviceRateKpi.invoicedPartnersCount + serviceRateKpi.mtdInvoicedPartnersCount;
  }

  getServiceRate(serviceRateKpi : ServiceRateKpi) {
    let rate;
    rate = (serviceRateKpi.plannedPartnersCount !=0 ? (serviceRateKpi.invoicedPartnersCount * 100 / serviceRateKpi.plannedPartnersCount) : "N/A");
    return (rate == "N/A" ? rate : Math.round(rate) + " %")
  }

  getMtdServiceRate(serviceRateKpi : ServiceRateKpi) {
    let rate;
    rate = (this.getCurrentMtdPlannedPartnersCount(serviceRateKpi) !=0 ? (this.getCurrentMtdInvoicedPartnersCount(serviceRateKpi) * 100 / this.getCurrentMtdPlannedPartnersCount(serviceRateKpi)) : "N/A");
    return (rate == "N/A" ? rate : Math.round(rate) + " %")
  }

  ServiceRateColor(serviceRateKpi : ServiceRateKpi) {
    return (this.getServiceRate(serviceRateKpi) >= 90 ? "green" : "red");
  }

  MtdServiceRateColor(serviceRateKpi : ServiceRateKpi) {
    return (this.getMtdServiceRate(serviceRateKpi) >= 90 ? "green" : "red");
  }

}